import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import emailErrorImage from '../../../../assets/images/graphics/email-error.svg';
import { AUTH_KEYS, NS } from '../../../../i18n/constants/keys';

export const FailureNotice = () => {
  const { t } = useTranslation(NS.auth);

  return (
    <Paper
      elevation={0}
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 4,
        maxWidth: 440,
        width: '100%',
        borderRadius: '24px',
        bgcolor: '#ffffff',
        boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.08)',
        textAlign: 'center',
      }}
    >
      <Box
        component='img'
        src={emailErrorImage}
        alt='email-verify'
        sx={{ width: 220, mb: 3 }}
      />
      <Typography
        variant='h5'
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '-0.01em',
          color: 'error.main',
          mb: 1.5,
        }}
      >
        {t(AUTH_KEYS.verifyEmail.failedTitle)}
      </Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
        {t(AUTH_KEYS.verifyEmail.failedMessage)}
      </Typography>
    </Paper>
  );
};

